<template>
  <div class="d-flex flex-column">
    <h2 class="title-indicators">Key indicators</h2>
    <div class="d-flex">
      <div :class="{'w-15': !showAllFields, 'w-10': showAllFields}" class="container-indicators">
        <div
          class="title-container-indicators mb-0 text-center"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Billable hours / Working hours (prod department)"
        >
          COM (Billability)
        </div>
        <div class=" h-100 d-flex align-items-center justify-content-center">{{ keyIndicators.billability }}%</div>
      </div>
      <div :class="{'w-27': !showAllFields, 'w-20': showAllFields}" class="container-indicators">
        <div
          class="title-container-indicators"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Billable hours / Working hours (prod department)"
        >
          Hours
        </div>
        <div class="d-flex justify-content-between row-border font">
          Working (prod department):
          <span>{{ keyIndicators.hoursWorkingProdDep }}</span>
        </div>
        <div class="d-flex pt-12 justify-content-between row-border font">
          Billable hours: <span>{{ keyIndicators.hoursBillable }}</span>
        </div>
        <div class="d-flex pt-12 justify-content-between font">
          Working + sick and vacations (all)
          <span>{{ keyIndicators.hoursWorkingSickDayVacationAll }}</span>
        </div>
      </div>
      <div :class="{'w-27': !showAllFields, 'w-20': showAllFields}" class="container-indicators">
        <div
          class="title-container-indicators"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Billable hours / Working hours (prod department)"
        >
          Diff with PL and prepaid
        </div>
        <div
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          :title="getTooltipText('diffWithPLAmount')"
          class="d-flex row-border justify-content-between font"
        >
          Amount (diff with pl):
          <span>${{ keyIndicators.diffWithPLAmount }}</span>
        </div>
        <div
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          :title="getTooltipText('prepaidHours')"
          class="d-flex pt-12 row-border justify-content-between font"
        >
          Prepaid hours: <span>{{ keyIndicators.prepaidHours }}</span>
        </div>
        <div
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          :title="getTooltipText('prepaidAmount')"
          class="d-flex pt-12 justify-content-between font"
        >
          Prepaid amount: <span>${{ keyIndicators.prepaidAmount }}</span>
        </div>
      </div>
      <div v-if="showAllFields" class="container-indicators w-20">
        <div
          class="title-container-indicators"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Billable hours / Working hours (prod department)"
        >
          Payouts
        </div>
        <div class="d-flex row-border justify-content-between font">
          Prod department: <span>${{ keyIndicators.payoutsProdDep }}</span>
        </div>
        <div class="d-flex pt-12 row-border justify-content-between font">
          Non-prod department:
          <span>${{ keyIndicators.payoutsNonProdDep }}</span>
        </div>
        <div class="d-flex pt-12 row-border justify-content-between font">
          Partner's extra payments:
          <span>${{ keyIndicators.payoutsPartnerExtraPayments }}</span>
        </div>
        <div class="d-flex pt-12 justify-content-between font">
          All: <span>${{ payoutsAll }}</span>
        </div>
      </div>
      <div v-if="showAllFields" class="container-indicators w-20">
        <div
          class="title-container-indicators"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Billable hours / Working hours (prod department)"
        >
          Expenses
        </div>
        <div class="d-flex row-border justify-content-between font">
          Regular: <span>${{ keyIndicators.expensesRegular }}</span>
        </div>
        <div class="d-flex pt-12 row-border justify-content-between font">
          Project related:
          <span>${{ keyIndicators.expensesProjectRelated }}</span>
        </div>
        <div class="d-flex pt-12 justify-content-between font">
          All: <span>${{ expensesAll }}</span>
        </div>
      </div>
      <div :class="{'w-27': !showAllFields, 'w-20': showAllFields}" class="container-indicators mr-0">
        <div
          class="title-container-indicators"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Billable hours / Working hours (prod department)"
        >
          Overhead
        </div>
        <div
          v-if="showAllFields"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Expenses (regular) + Payouts (non-prod department)"
          class="d-flex row-border justify-content-between font"
        >
          Monthly <span>${{ keyIndicators.overheadAmount }}</span>
        </div>
        <div
          v-else
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Overhead (monthly) / Hours (working of prod department)"
          class="d-flex row-border justify-content-between font"
        >
          Hourly <span>${{ keyIndicators.overheadHourly }}</span>
        </div>
        <div
          v-if="showAllFields"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Overhead (monthly) / Hours (working of prod department)"
          class="d-flex row-border justify-content-between pt-12 font"
        >
          Hourly <span>${{ keyIndicators.overheadHourly }}</span>
        </div>
        <div
          v-else
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Overhead (monthly) / (Expenses all + Payouts all)"
          class="d-flex justify-content-between pt-12 font"
        >
          Monthly % <span>{{ keyIndicators.overheadPercent }}%</span>
        </div>
        <div
          v-if="showAllFields"
          v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
          title="Overhead (monthly) / (Expenses all + Payouts all)"
          class="d-flex justify-content-between pt-12 font"
        >
          Monthly % <span>{{ keyIndicators.overheadPercent }}%</span>
        </div>
        <div v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pp-key-indicators-table',
  props: {
    keyIndicators: {
      type: Object,
      default: () => {}
    },
    showAllFields: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    expensesAll () {
      const expensesAll = this.keyIndicators.expensesRegular + this.keyIndicators.expensesProjectRelated
      return expensesAll.toFixed(2)
    },
    payoutsAll () {
      const expensesAll = this.keyIndicators.payoutsProdDep + this.keyIndicators.payoutsNonProdDep + this.keyIndicators.payoutsPartnerExtraPayments
      return expensesAll.toFixed(2)
    }
  },
  methods: {
    getTooltipText (field) {
      if (field === '') {
      } else if (field === 'diffWithPLAmount') {
        return `The difference between values of PL revenue and PP revenue.

Revenue:

Revenue. PL - фактически оплаченные деньги в месяце

Revenue. PP (project) - деньги оплаченные в любом месяце на за текущий период

Revenue. PP (people) - деньги оплаченные в любом месяце, за текущий период и отработанные (часы проходят как billable hours - закрытые часы)`
      } else if (field === 'prepaidHours') {
        return `Column billable hours (value in brackets) and this is equivalent of prapaid hours in Hours and Payments reports`
      } else if (field === 'prepaidAmount') {
        return `Prepaid hours * average external rate)`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container-indicators {
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  background-color: white;
  margin-right: 20px;
  border-radius: 10px;
  .title-container-indicators {
    color: $fontColor2;
    font-size: 11px;
    margin-bottom: 24px;
    font-weight: 400;
    text-transform: uppercase;
  }
}

.title-indicators {
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 22px;
}

.font {
  font-size: 13px;
}

.w-27 {
  width: 27%;
}

.w-15 {
  width: 15%;
}

.w-20 {
  width: 20%;
}

.w-10 {
  width: 10%;
}

.row-border {
  padding-bottom: 12px;
  border-bottom: 1px solid $bgColor2;
}

.pt-12 {
  padding-top: 12px;
}
</style>
